<template>
    <div class="outer">

        <el-dialog width="65%" :title="buyDialogTitle" :close-on-click-modal="false" :visible="claimVisible" @close="closeBuyDialog">
            <div class="flex-space-between" style="align-items: flex-start;">
                <div class="left" :style="{width: '100%'}">
                    <el-card style="margin-bottom: 30px">
                        <div class="flex-space-between" slot="header">
                            <span>采购单基本信息</span>

                            <el-button type="primary" icon="el-icon-folder-checked" v-if="claimDialogType === 'edit'" @click="saveBaseInfo">保存基本信息</el-button>
                        </div>
                        <el-form ref="claimForm" :model="claimForm" :rules="claimRules" label-width="120px">
                            <el-row>
                                <el-col :span="12">
                                    <el-form-item label="供应商名称" required prop="supplierId">
                                        <el-select disabled style="width: 100%" v-model="claimForm.supplierId" placeholder="请选择">
                                            <el-option v-for="item in supplierList" :key="item.id" :value="item.id" :label="item.supplierName"></el-option>
                                        </el-select>
                                    </el-form-item>
                                </el-col>
                                <!-- <el-col :span="12">
                                    <el-form-item label="优惠折扣率(%)" required prop="discountRate">
                                        <el-input disabled :max="100" style="width: 100%" v-model="claimForm.discountRate" type="number" :min="1"
                                            placeholder="请输入">
                                        </el-input>
                                    </el-form-item>
                                </el-col> -->
                                <el-col :span="12">
                                    <el-form-item label="预采购日期" required prop="purchaseDate">
                                        <el-date-picker
                                            disabled
                                            
                                            style="width: 100%"
                                            v-model="claimForm.purchaseDate"
                                            type="date"
                                            value-format="yyyy-MM-dd"
                                            placeholder="选择日期">
                                        </el-date-picker>
                                    </el-form-item>
                                </el-col>
                            </el-row>

                            <el-row >
                                <el-col :span="12">
                                    <el-form-item label="支付方式" required prop="payMode">
                                        <el-select disabled style="width: 100%" v-model="claimForm.payMode" placeholder="请选择">
                                            <el-option label="京东支付" :value="'1'"></el-option>
                                            <el-option label="淘宝支付" :value="'2'"></el-option>
                                            <el-option label="其他方式" :value="'3'"></el-option>
                                        </el-select>
                                    </el-form-item>
                                </el-col>
                                
                            </el-row>
                            <el-row>
                               <el-col :span="24">
                                    <el-form-item label="备注" required prop="remarks">
                                        <el-input disabled style="width: 100%" v-model="claimForm.remarks" type="textarea"
                                            placeholder="请输入">
                                        </el-input>
                                    </el-form-item>
                                </el-col>
                            </el-row>
                        </el-form>
                    </el-card>
                    <el-card style="margin-bottom: 30px">
                        <div class="flex-space-between" slot="header">
                            <span>采购的货物</span>
                        </div>

                        <div style="overflow: auto;height: 250px;">
                            <el-table border style="width: 100%;" :data="claimGoodsList">
                                <el-table-column align="center" label="货物名称" prop="goodsName">
                                </el-table-column>
                                <!-- <el-table-column align="center" label="关联请购单" prop="requestNo">
                                    <template slot-scope="scope">
                                        <span>{{ scope.row.requestNo || '--' }}</span>
                                    </template>
                                </el-table-column> -->
                                <el-table-column align="center" label="货物型号" prop="goodsType">
                                </el-table-column>
                                <el-table-column align="center" label="货物配置" prop="goodsConfig">
                                    <template slot-scope="scope">
                                        <el-popover trigger="hover" placement="top" width="300">
                                            <p>{{ scope.row.goodsConfig }}</p>
                                                <div slot="reference">
                                                <p size="medium" style="white-space: nowrap;overflow: hidden;text-overflow:ellipsis;">{{ scope.row.goodsConfig}}</p>
                                            </div>
                                        </el-popover>
                                    </template>
                                </el-table-column>
                                <el-table-column align="center" label="货物单位" prop="goodsUnit">
                                </el-table-column>
                                <el-table-column align="center" label="货物品牌" prop="goodsBrand">
                                </el-table-column>
                                <el-table-column align="center" label="库存数量" prop="whGoodsNum" width="100">
                                </el-table-column>
                                <el-table-column align="center" label="采购数量" prop="goodsNum" width="120">
                                    <template slot-scope="scope">
                                        <span>{{ scope.row.goodsNum }}</span>
                                    </template>
                                </el-table-column>
                                <el-table-column align="center" label="采购单价(元)" prop="factPurchasePrice" width="130">
                                    <template slot-scope="scope">
                                        <el-input style="width: 100px" type="number" v-if="claimDialogType === 'add'" :min="0"
                                        v-model="scope.row.factPurchasePrice"></el-input>
                                        <span v-else>{{ scope.row.factPurchasePrice }}</span>
                                    </template>
                                </el-table-column>
                                <el-table-column align="center" label="采购小计(元)" prop="factPurchaseSubtotal" width="80">
                                    <template slot-scope="scope">
                                        <span>{{ (scope.row.goodsNum * scope.row.factPurchasePrice || 0).toFixed(2) }}</span>
                                    </template>
                                </el-table-column>
                            </el-table>
                        </div>
                        
                        <div class="totalPrice">
                            <div class="price">合计: {{ this.claimForm.amountPayable }}元</div>
                        </div>
                    </el-card>
                </div>

            </div>
            <span slot="footer" class="dialog-footer">
                <el-button v-if="claimDialogType === 'detail'" @click="claimVisible = false">取 消</el-button>
                <el-button type="danger" v-if="claimDialogType === 'approval'" @click="buyApproval(2)">驳 回</el-button>
                <el-button type="primary" v-if="claimDialogType === 'approval'" @click="buyApproval(1)">通 过</el-button>
            </span>
        </el-dialog>

        <div class="topSearch">
            <el-form class="queryRow" inline :model="queryForm">
                <el-form-item label="供应商名称" class="queryCol">
                    <el-select v-model="queryForm.supplierId" @change="onSearch" clearable
                    @clear="onSearch">
                        <el-option v-for="item in supplierList" :key="item.id" :value="item.id" :label="item.supplierName">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="本人是否审批" class="queryCol">
                    <el-select 
                    v-model="queryForm.func"
                    placeholder="请选择" 
                    @change="onSearch">
                        <el-option value="2" label="未审批"></el-option>
                        <el-option value="1" label="已审批"></el-option>
                    </el-select>
                </el-form-item>
            </el-form>
        </div>

        <el-table
        class="table"
        v-loading="loading"
        style="width: 100%;height: 68vh;overflow: auto;"
        :row-style="{ height: '50px' }"
        border
        :data="buyList">
            <template slot="empty">
                <el-empty :image-size="150"></el-empty>
            </template>
            <el-table-column
                align="center"
                label="采购单编号"
                prop="purchaseNo">
            </el-table-column>
            <el-table-column
                align="center"
                label="供应商名称"
                prop="supplierName">
            </el-table-column>
            <el-table-column
                align="center"
                label="支付方式"
                prop="payModeName">
            </el-table-column>
            <el-table-column
                align="center"
                label="采购单状态"
                prop="purchaseState">
                <template slot-scope="scope">
                    <el-tag v-if="scope.row.purchaseState === '1'" type="info">{{scope.row.purchaseStateName}}</el-tag>
                    <el-tag v-else-if="scope.row.purchaseState === '2'" type="success">{{scope.row.purchaseStateName}}</el-tag>
                    <el-tag v-else-if="scope.row.purchaseState === '3'" type="danger">{{scope.row.purchaseStateName}}</el-tag>
                    <el-tag v-else-if="scope.row.purchaseState === '4'" type="primary">{{scope.row.purchaseStateName}}</el-tag>
                </template>
            </el-table-column>
            <el-table-column
                align="center"
                label="本人是否审批"
                prop="purchaseState">
                <template slot-scope="scope">
                    <el-tag v-if="queryForm.func === '2'" type="info">未审批</el-tag>
                    <el-tag v-else type="success">已审批</el-tag>
                </template>
            </el-table-column>
            <el-table-column
                align="center"
                label="预采购日期"
                prop="purchaseDate">
                <template slot-scope="scope">
                    {{ scope.row.purchaseDate.split(' ')[0] }}
                </template>
            </el-table-column>
            <el-table-column
                align="center"
                label="实际应付金额(元)"
                prop="factPayable">
            </el-table-column>
            <el-table-column
                align="center"
                label="操作人"
                prop="dealUserName">
            </el-table-column>
            <el-table-column
                align="center"
                label="备注"
                prop="remarks">
            </el-table-column>
            <el-table-column
                align="center"
                v-if="queryForm.func === '1'"
                label="审批意见"
                prop="opinion">
            </el-table-column>
            <el-table-column
                align="center"
                label="操作"
                prop="operate">
                <template slot-scope="scope">
                    <el-button type="text" icon="el-icon-document" @click="openMainDialog('detail',scope.row.purchaseNo)">详情</el-button>
                    <el-button type="text" v-if="scope.row.purchaseState === '1' && queryForm.func == '2'" icon="el-icon-edit" @click="openMainDialog('approval',scope.row.purchaseNo)">审批</el-button>
                </template>
            </el-table-column>
        </el-table>

        <div class="pageination">
            <el-pagination
            @size-change="onSizeChange"
            @current-change="onCurrentChange"
            :total="total"
            :page-size="queryForm.limit"
            :page-sizes="[10, 20, 30, 40, 50, 100]"
            :current-page="queryForm.page"
            background
            layout="sizes, prev, pager, next, jumper, ->, total">
            </el-pagination>
        </div>
    </div>
</template>
<script>
import { getSupplierList } from '@/api/goods/goodsBusiness.js';
import {
    changePurchaseState,
    getBuyPurchase,
    queryXzPurchase,
    approvalStageList,
    applyApprovalReject,
    purchaseApprovedList
} from '@/api/goods/buyForm.js';
export default {
    data() {
        var checkRate = (rule, value, callback) => {
            if (!value) {
                return callback(new Error('优惠折扣率不能为空'));
            }
            
            if (value <= 0 || value > 100) {
                return callback(new Error('优惠折扣率必须在1到100之间'));
            }

            callback();
        };
        return {
            roleId: sessionStorage.getItem('uid'),
            stageList: [], // 采购单审批记录
            loading: false, // 加载状态
            claimDialogType: '', // 申领单弹窗类型 add新增 edit编辑
            total:0, // 采购单总数
            queryForm:{
                func: '2', // 1 审批和已审批记录
                supplierId: null,  
                purchaseState: "1",
                page: 1,
                limit: 10,
            }, // 查询表单
            claimVisible: false, // 申领单弹窗显隐
            claimForm:{
                amountPayable: 0,
                factPayable: 0,
                supplierId: '',
                discountRate: 100,
                payMode: '',
                purchaseDate: '',
                remarks: '',
            }, // 申领单填写表单
            claimRules:{
                supplierId: [
                    { required: true, message: '请选择供应商名称' },
                ],
                discountRate: [
                    { validator: checkRate }
                ],
                payMode: [
                    { required: true, message: '请选择支付方式' },
                ],
                purchaseDate: [
                    { required: true, message: '请选择预采购日期' },
                ],
                remarks: [
                    { required: true, message: '请输入备注' },
                ],
            }, // 申领单表单验证
            claimGoodsList:[], // 申领的库存列表
            buyList:[], // 采购单列表
            supplierList: [], // 供应商列表
            buyDialogTitle: '', // 采购单弹窗标题
        }
    },
    created(){
        this.getSupplierList();
        this.getBuyPurchase();
    },
    computed:{
    },
    watch: {
    },
    methods:{
       
        // 采购单审批
        buyApproval(approvalResult){
            let approvalTitle = approvalResult === 1 ? '审批通过' : '审批驳回';
            this.$prompt('请输入审批意见',
             approvalTitle, {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                inputValue: approvalResult === 1 ? '同意!' : '',
                inputPattern: /.+/,
                inputErrorMessage: '审批意见不能为空'
             }).then(({ value }) => {
                applyApprovalReject({
                    approvalType: 6,
                    applyCode: this.claimForm.purchaseNo,
                    approvalResult,
                    opinion: value
                }).then(res => {
                    if(res.code === 200){
                        this.$message({
                            type: 'success',
                            message: '操作成功!',
                        });
                        this.queryForm.func = '1';
                        this.claimVisible = false;
                        this.getBuyPurchase();
                    }
                })
             })
        },
        // 当每页条数变化
        onSizeChange(e){
            this.queryForm.page = 1;
            this.queryForm.limit = e;
            this.getBuyPurchase();
        },
        // 搜索
        onSearch(){
            this.queryForm.page = 1;
            this.getBuyPurchase();
        },
        // 当页码发生变化时
        onCurrentChange(e){
            this.queryForm.page = e;
            this.getBuyPurchase();
        },
        // 获取采购单待审批和已审批记录
        getBuyPurchase(){
            this.loading = true;
            purchaseApprovedList(this.queryForm).then(res => {
                if(res.code === 200){
                    this.total = res.count;
                    this.buyList = res.data;
                    this.loading= false;
                }
            })
        },
        // 关闭采购单弹窗
        closeBuyDialog(){
            this.claimForm = {
                amountPayable: 0,
                factPayable: 0,
                supplierId: '',
                discountRate: 100,
                payMode: '',
                purchaseDate: '',
                remarks: '',
            };
            this.$refs.claimForm.resetFields();
            this.claimGoodsList = [];
            this.claimVisible = false;
        },
        // 获取采购单审批记录
        getApprovalStageList(purchaseNo){
            approvalStageList({
                applyCode: purchaseNo,
            }).then(res => {
                if(res.code === 200){
                    this.stageList = res.data;
                }
            })
        },
        // 打开新建采购单弹窗
        openMainDialog(type, purchaseNo){
            this.claimDialogType = type;

            if(type === 'detail'){
                this.buyDialogTitle = '采购单详情';
            }else if(type === 'approval'){
                this.buyDialogTitle = '审批采购单';
            }

            this.getApprovalStageList(purchaseNo);
            queryXzPurchase({ purchaseNo }).then(res => {
                if(res.code === 200){
                    this.claimForm = res.result;
                    this.claimGoodsList = res.result.tbXzPurchaseGoodsListModel2List;
                    this.claimVisible = true;
                }
            })
        },
        // 获取供应商列表（仅行政供应商，排除商务进销存供应商）
        getSupplierList(){
            getSupplierList({
                page: 1,
                limit: 2000,
                category: '行政'
            }).then(res => {
                if(res.code === 200){
                    this.supplierList = (res.data || []).filter(item => String(item.category || '行政') !== '商务')
                }
            })
        },
    },
}
</script>
<style lang="scss" scoped>
.outer{
    height: 80vh;
    .totalPrice{
        display: flex;
        justify-content: flex-end;
        margin-top: 15px; 
        font-size: 16px;

        .price{
            margin-right: 20px
        }
    }
    .el-form-item{
        margin-right: 20px;
    }
    .pageination{
        position: absolute;
        bottom: 10px;
        right: 10px;
        display: flex; 
        justify-content: flex-end;
        margin-top: 5px
    }
    .topSearch{
        display: flex;
        justify-content: space-between;
        align-items: flex-start;
    }
    .queryRow {
        overflow: hidden;
        display: flex;

        .queryName {
            width: 300px;
            margin-right: 10px;
        }

        .dataPicker {
            margin-right: 10px;
        }
    }
    .detailTable{
        ::v-deep .el-checkbox__input{
            &.is-checked{
                .el-checkbox__inner{
                    background-color: #409EFF;
                    border-color: #409EFF;
                }
            }
        }
    }

    .divider{
        width: 1px;
        height: 620px;
        background-color: #e8e8e8;
        margin: 0 20px;
    }
     
    .table{
        ::v-deep .el-tooltip__popper{
            font-size: 14px; 
            max-width:40% 
        }
   
        ::v-deep .el-table__cell{
            >:empty::before{
                content: '--';
                color: gray;
            }
        }
    }
}
</style>
